/**
 * Validates that a string is either a valid e-mail OR a phone number
 * with at least 9 digits (CZ landline minimum). Used for forms that
 * accept either contact channel in a single field.
 */
export function isValidContact(value) {
  if (!value) return false;
  const s = String(value).trim();
  if (!s) return false;
  if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s)) return true;
  const digits = s.replace(/[^\d]/g, "");
  return digits.length >= 9;
}

export function looksLikeEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
}

export const PROPERTY_TYPES = [
  "Kancelář",
  "SVJ / bytový dům",
  "Provoz / firma",
  "Jiné",
];

export const FREKVENCE = [
  "Nevím (doporučíte)",
  "1× týdně",
  "2–3× týdně",
  "Denně",
];
